module.exports = __webpack_public_path__ + "static/monei_pay_4_es-415e1db6dacc1268cbde0f34dd91029c.png";